<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <el-select class="search_select search_inputBox" v-model="params.salesman_id" placeholder="供应商" filterable>
                    <el-option v-for="list in supplierList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.salesman_id" placeholder="客户" filterable>
                    <el-option v-for="list in customerList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="params.time" readonly value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="单据日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.salesman_id" placeholder="销售员">
                    <el-option v-for="list in saleList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn">新增</el-button>
                <el-button class="funcPublicBtn funcPublicBtnChecked">提交保存</el-button>
            </div>
            <div class="tableBox">
                <el-table :data="list" style="width: 100%" border stripe highlight-current-row size="mini" height="100%">
                    <!-- <el-table-column type="index"></el-table-column>
                    <el-table-column type="selection"></el-table-column> -->
                    <el-table-column label="操作" prop=""></el-table-column>
                    <el-table-column label="品名" prop="">
                        <template></template>
                    </el-table-column>
                    <el-table-column label="品牌" prop=""></el-table-column>
                    <el-table-column label="等级" prop=""></el-table-column>
                    <el-table-column label="长度(cm)" prop=""></el-table-column>
                    <el-table-column label="厚度(cm)" prop=""></el-table-column>
                    <el-table-column label="总宽度(cm)" prop="" width="100px"></el-table-column>
                    <el-table-column label="件数" prop=""></el-table-column>
                    <el-table-column label="单包方数" prop=""></el-table-column>
                    <el-table-column label="方数" prop=""></el-table-column>
                    <el-table-column label="采购单价" prop=""></el-table-column>
                    <el-table-column label="采购金额" prop=""></el-table-column>
                    <el-table-column label="销售单价" prop="">
                    </el-table-column>
                    <el-table-column label="销售金额" prop=""></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">

</style>
<script>
    export default {
        data(){
            return{
                params:{
                    salesman_id:"",
                    time:""
                },
                time:"",
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                customerList:[],
                saleList:[],
                supplierList:[]
            }
        },
        created(){
            this.$getCustomerList().then(res=>{
                this.customerList=res.data.data;
            })
            this.$getSalemanList().then(res=>{
                this.saleList=res.data.data;
            })
            this.getSupplierList().then(res=>{
                this.supplierList=res.data.data;
            })
        },
        methods:{

        },
    }
</script>
